import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgLinkOut = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19 15v3.222c0 .43-.348.778-.778.778H5.778A.778.778 0 0 1 5 18.222V5.778c0-.43.348-.778.778-.778H9a1 1 0 0 0 0-2H5.778A2.778 2.778 0 0 0 3 5.778v12.444A2.778 2.778 0 0 0 5.778 21h12.444A2.778 2.778 0 0 0 21 18.222V15a1 1 0 1 0-2 0Zm1.924-11.383A.997.997 0 0 1 21 4v5a1 1 0 1 1-2 0V6.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L17.586 5H15a1 1 0 1 1 0-2h5a.997.997 0 0 1 .924.617Z", fill: color }));
};
export default factorySvgIcon(SvgLinkOut);
//# sourceMappingURL=SvgLinkOut.js.map